import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import AddPropertyPopup from './AddPropertyPopup';
import AddNewPropertyButton from './AddNewPropertyButton';
import ProductPropertyItem from './ProductPropertyItem';
import { ErrorHandler } from '../../ErrorHandler';
import { PROPERTY_TYPE_BOOLEAN } from '../../../constant';
import ProductPropertiesSearchInput from './ProductPropertiesSearchInput';

const createKeyForElement = (element) => {
    return element.id + element.categoryName + element.propertyName;
};

const filterBySearchValue = (property, searchPropertyValue) => {
    return property.localizedName.toLowerCase().includes(searchPropertyValue.toLowerCase());
};

const filterBySearchValueIsExists = (propertiesList, searchValue) => {
    return propertiesList.filter(it => filterBySearchValue(it, searchValue)).length > 0;
};

const ProductPropertiesListHandler = ({properties}) => {
    const { i18n } = useTranslation();
    const [searchPropertyValue, setSearchPropertyValue] = useState('');
    const [propertiesList, setPropertiesList] = useState([]);

    useEffect(() => {
        console.log(properties);
        if (properties) {
            setPropertiesList(properties);
        }
    }, [properties]);

    const changeSearchValue = (value) => {
        setSearchPropertyValue(value);
    };

    return (
        <>
            <div className="product__tab-property">
                <AddNewPropertyButton />
                <ProductPropertiesSearchInput changeSearchValue={changeSearchValue} />
            </div>
            <ul className={`product__add-list product__add-list_wrap}`}>
                {propertiesList && propertiesList.length && filterBySearchValueIsExists(propertiesList, searchPropertyValue) ? 
                    <>
                        {propertiesList.filter(it => it.propertyType === PROPERTY_TYPE_BOOLEAN && filterBySearchValue(it, searchPropertyValue)).length ?
                            <li className="product__add-item">
                                <ul className="product__form-list">
                                    {propertiesList.filter(it => it.propertyType === PROPERTY_TYPE_BOOLEAN).map(item => (
                                        <li key={createKeyForElement(item)}>
                                            <ProductPropertyItem
                                                propertyId={item.id}
                                                categoryName={item.categoryName}
                                                localizedName={item.localizedName}/>
                                        </li>
                                    ))}
                                </ul>
                            </li>
                            :
                            null
                        }
                        {propertiesList.filter(it => it.propertyType !== PROPERTY_TYPE_BOOLEAN && filterBySearchValue(it, searchPropertyValue)).map(item => (
                            <li key={createKeyForElement(item)} className="product__add-item">
                                <ProductPropertyItem
                                    propertyId={item.id}
                                    categoryName={item.categoryName}
                                    localizedName={item.localizedName}/>
                            </li>
                        ))}
                    </>
                    :
                    searchPropertyValue ? <ErrorHandler titleValue={i18n.t('app.page.profile.emptyData')} /> : null}
            </ul>
            <AddPropertyPopup />
        </>
    );
};

export default ProductPropertiesListHandler;
